export default {
  US: { mask: '(000)000-00-00' },
  GB: { mask: '00000 000000' },
  ZA: { mask: '000-0000000' },
  IE: { mask: '000 000 0000' },
  FR: { mask: '00 00 00 00 00' },
  DE: { mask: '00000 0000000' }
}
